import { Button, EmptyState, type Omittable } from "@salestrak/ui";

type InboxEmptyStateProps = Omittable<{
  activeTab: "all" | "cleared";
  /** A kind filter is applied — the list is empty because nothing MATCHES,
   *  not because the inbox is clear, so don't celebrate. */
  filtered?: boolean;
  /** Clears the applied filter; renders the CTA the filtered copy points at. */
  onClearFilter?: () => void;
}>;

export function InboxEmptyState({
  activeTab,
  filtered,
  onClearFilter,
}: InboxEmptyStateProps) {
  if (filtered) {
    return (
      <EmptyState
        media="icon"
        icon="filter"
        title="No matching notifications"
        actions={
          onClearFilter ? (
            <Button size="sm" variant="outline" onClick={onClearFilter}>
              Clear filter
            </Button>
          ) : undefined
        }
      />
    );
  }
  return (
    <EmptyState
      media="icon"
      icon={activeTab === "all" ? "inbox" : "check-check"}
      title={activeTab === "all" ? "You're all caught up" : "No cleared notifications"}
    />
  );
}
